import React from 'react'

import { Icon } from '@fourthwall/components'
import { ArrowShortRightIcon, TickIcon } from '@fourthwall/icons'

import type { OfferCategory } from '../../../../types'
import { getDirectParentFromBreadcrumbs } from '../../../../utils/breadcrumbs'
import { SearchedText } from '../SearchedText'
import * as S from './styled'

type OptionProps = {
  searchValue: string
  option: OfferCategory
  selected?: boolean
  isFocused: boolean
  onSelect: (category: OfferCategory) => void
  onNavigateDown: (category: OfferCategory) => void
}

export const Option = ({
  searchValue,
  option,
  selected,
  isFocused,
  onSelect,
  onNavigateDown,
}: OptionProps) => {
  const hasChildren = option.children.length > 0
  const hasInnerClick = hasChildren && !searchValue

  const handleOuterClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    hasInnerClick ? onNavigateDown(option) : onSelect(option)
  }

  const renderRightContent = () => {
    if (searchValue) {
      return <S.Parent>{getDirectParentFromBreadcrumbs(option.breadcrumbs)}</S.Parent>
    }

    if (hasChildren) {
      return (
        <S.IconContainer>
          <Icon component={ArrowShortRightIcon} height={12} />
        </S.IconContainer>
      )
    }

    if (selected) {
      return (
        <S.IconContainer $bold>
          <Icon component={TickIcon} height={12} />
        </S.IconContainer>
      )
    }

    return null
  }

  return (
    <S.Container $selected={selected} $focused={isFocused} tabIndex={-1} onClick={handleOuterClick}>
      <S.CategoryButton $selected={selected}>
        {searchValue ? <SearchedText text={option.name} search={searchValue} /> : option.name}
      </S.CategoryButton>
      {renderRightContent()}
    </S.Container>
  )
}
